import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=56a2878a&scoped=true&"
import script from "./NewCampaign.vue?vue&type=script&lang=ts&"
export * from "./NewCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewCampaign.vue?vue&type=style&index=1&id=56a2878a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2878a",
  null
  
)

export default component.exports